// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Scp {
  width: 125px;
  height: 100px;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  position: relative;
  z-index: 1000;
  cursor: pointer;
}
.Scp-saturation {
  position: relative;
  width: calc(100% - 25px);
  height: 100%;
  background: linear-gradient(to right, #fff 0%, #f00 100%);
  float: left;
  margin-right: 5px;
}
.Scp-brightness {
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, #000 0%, rgba(255,255,255,0) 100%);
}
.Scp-sbSelector {
  border: 1px solid;
  position: absolute;
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 10px;
  top: -7px;
  left: -7px;
  box-sizing: border-box;
  z-index: 10;
}
.Scp-hue {
  width: 20px;
  height: 100%;
  position: relative;
  float: left;
  background: linear-gradient(to bottom, #f00 0%, #f0f 17%, #00f 34%, #0ff 50%, #0f0 67%, #ff0 84%, #f00 100%);
}
.Scp-hSelector {
  position: absolute;
  background: #fff;
  border-bottom: 1px solid #000;
  right: -3px;
  width: 10px;
  height: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/color.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,yDAAyD;EACzD,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sEAAsE;AACxE;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,4GAA4G;AAC9G;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,WAAW;EACX,WAAW;AACb","sourcesContent":[".Scp {\n  width: 125px;\n  height: 100px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  position: relative;\n  z-index: 1000;\n  cursor: pointer;\n}\n.Scp-saturation {\n  position: relative;\n  width: calc(100% - 25px);\n  height: 100%;\n  background: linear-gradient(to right, #fff 0%, #f00 100%);\n  float: left;\n  margin-right: 5px;\n}\n.Scp-brightness {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to top, #000 0%, rgba(255,255,255,0) 100%);\n}\n.Scp-sbSelector {\n  border: 1px solid;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  background: #fff;\n  border-radius: 10px;\n  top: -7px;\n  left: -7px;\n  box-sizing: border-box;\n  z-index: 10;\n}\n.Scp-hue {\n  width: 20px;\n  height: 100%;\n  position: relative;\n  float: left;\n  background: linear-gradient(to bottom, #f00 0%, #f0f 17%, #00f 34%, #0ff 50%, #0f0 67%, #ff0 84%, #f00 100%);\n}\n.Scp-hSelector {\n  position: absolute;\n  background: #fff;\n  border-bottom: 1px solid #000;\n  right: -3px;\n  width: 10px;\n  height: 2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
